import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { SchoolSelect } from '../../components/common';
import { t, type MessageKey } from '../../i18n';
import { InvoicesTab } from './InvoicesTab';
import { PaymentsTab } from './PaymentsTab';
import { StructureTab } from './StructureTab';

type Tab = 'structure' | 'invoices' | 'payments';

export function FeesPage() {
  const { can } = useAuth();
  const [schoolId, setSchoolId] = useState('');
  const [tab, setTab] = useState<Tab>('invoices');
  const tabs: Tab[] = [];
  if (schoolId && can('fees.view', schoolId)) tabs.push('invoices', 'structure');
  if (schoolId && can('payments.view', schoolId)) tabs.push('payments');
  const active = tabs.includes(tab) ? tab : tabs[0];

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('fees.title')}</h1>
      <SchoolSelect value={schoolId} onChange={setSchoolId} />
      {schoolId && active && (
        <>
          <div
            role="tablist"
            aria-label={t('fees.title')}
            className="flex flex-wrap gap-1 border-b border-slate-200"
          >
            {tabs.map((name) => (
              <button
                key={name}
                role="tab"
                type="button"
                aria-selected={active === name}
                onClick={() => setTab(name)}
                className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${active === name ? 'border-brand-700 text-brand-700' : 'border-transparent text-slate-600'}`}
              >
                {t(`fees.tab.${name}` as MessageKey)}
              </button>
            ))}
          </div>
          <div role="tabpanel">
            {active === 'structure' && <StructureTab schoolId={schoolId} />}
            {active === 'invoices' && <InvoicesTab schoolId={schoolId} />}
            {active === 'payments' && <PaymentsTab schoolId={schoolId} />}
          </div>
        </>
      )}
    </div>
  );
}
